import { AccessProvider } from '@/providers/AccessProvider';
import { AuthProvider } from './AuthProvider';
import ThemeProvider from './ThemeProvider';

export default (props: React.PropsWithChildren) => {
  const { children } = props;
  return (
    <AuthProvider>
      <AccessProvider>
        <ThemeProvider>{children}</ThemeProvider>
      </AccessProvider>
    </AuthProvider>
  );
};
